export const API_URL = import.meta.env.VITE_API_URL ?? 'https://sls-96aa.onrender.com';
export const API_BASE = `${API_URL}/api/v1`;

// Web Push (VAPID) public key. Non-secret — the browser sends it to the push
// service to authorise this app's subscriptions. Must match the backend's
// VAPID_PUBLIC_KEY. Generate a pair with `npx web-push generate-vapid-keys`.
export const VAPID_PUBLIC_KEY = import.meta.env.VITE_VAPID_PUBLIC_KEY ?? '';

// Firebase is used ONLY for Analytics (GA4) now — push moved to standard Web
// Push (VAPID). All fields non-secret; analytics no-ops if measurementId unset.
export const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? '',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? '',
};
